



























































































import { Component, Vue, Watch } from 'vue-property-decorator';
import { SpecOutListModule } from '@/store/modules/specOutList';
import GiganautVueDialog from '@/components/Shared/GiganautVueDialog';
import { AgencySettingsModule } from '@/store/modules/agencySettings';
import ListUtils from '@/lib/listUtils';
import SpecOutStatus from '@/components/SpecOuts/Display/SpecOutStatus.vue'

@Component({
    name: 'SpecOutListSearchCriteria',
    components: { SpecOutStatus }
})
export default class extends GiganautVueDialog {

  public dialog = false;

  @Watch('dialog')
  async onDialogChanged(val: boolean, oldVal: boolean) {
    if (val) {
      if (AgencySettingsModule.agencyUsers) {
        AgencySettingsModule.getAgencyUsers();
      }
      if (AgencySettingsModule.branches) {
        await AgencySettingsModule.getBranches();
      }
    }
  }

  get branches() {
    return AgencySettingsModule.branches;
  }

  get searchOptions() {
      return SpecOutListModule.filterSpecOutSearchViewModel;
  }

  get currentSearchCriteria() {
      return SpecOutListModule.currentSpecOutSearchCriteria;
  }

  get agencyUsers() {
    return AgencySettingsModule.agencyUsers;
  }

  get statusOptions() {
    return ListUtils.specOutStatuses();
  }

  get loading() {
    return SpecOutListModule.loading;
  }

  async search() {
    this.dialog = false;
    await SpecOutListModule.searchSpecOuts()
  }
}
